import React, { useEffect, useState } from 'react';
import { Alert, Button, Card, Col, Container, Form, Row, Spinner } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';

// Import Images
import logoDark from '../../assets/images/logo-dark.png'
import logoLight from '../../assets/images/logo-light.png'
import img1 from '../../assets/images/auth/img-1.png'
import { Link, useNavigate } from 'react-router-dom';

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from 'reselect';

// Formik validation
import * as Yup from "yup";
import { useFormik } from "formik";

import { loginUser, socialLogin, resetLoginFlag } from "../../slices/thunk";
import withRouter from '../../Common/withRouter';
import { useLoginMutation, useVerifyTokenMutation } from '../../Redux/auth/authApi';

//Social Media Imports
// import { GoogleLogin } from "react-google-login";
// import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";

//Import config
// import { facebook, google } from "../../config";

const Login = (props) => {
    const [loginFn, { isSuccess, error: loginErr, data, isLoading }] = useLoginMutation()
    const [verifyFn, { isSuccess: veifySuccess }] = useVerifyTokenMutation()

    const navigate = useNavigate()
    document.title = "Login | Toner eCommerce + Admin React Template";

    const dispatch = useDispatch();
    const selectUser = (state) => state.Account.user;
    const selectError = (state) => state.Login.error;

    const selectUserData = createSelector(
        selectUser,
        selectError,
        (user, error) => ({
            user,
            error,
        })
    );
    const { user, error } = useSelector(selectUserData);


    const [passwordShow, setPasswordShow] = useState(false);




    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: "",
            password: "",
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
            password: Yup.string().required("Please Enter Your Password"),
        }),
        onSubmit: (values) => {
            // dispatch(loginUser(values, props.router.navigate));

            loginFn(values)

        }
    });

    const signIn = (type) => {
        dispatch(socialLogin(type, props.router.navigate));
    };

    //handleGoogleLoginResponse
    // const googleResponse = (response) => {
    //     signIn(response, "google");
    // };

    // //handleFacebookLoginResponse
    // const facebookResponse = (response) => {
    //     signIn(response, "facebook");
    // };

    //for facebook and google authentication
    const socialResponse = (type) => {
        signIn(type);
    };


    useEffect(() => {
        setTimeout(() => {
            dispatch(resetLoginFlag());
        }, 3000);
    }, [dispatch, error]);



    useEffect(() => {
        if (isSuccess) {
            const message = data?.message || "Login success";

            toast.success(message);
            // dispatch(setVerifyData(data?.response?.additional))
            // navigate(`/auth-twostep-basic`)
            verifyFn(data?.response?.token)
        }
        if (loginErr) {
            if ('data' in loginErr) {
                const errorData = loginErr?.data?.message || 'something went wrong';
                toast.error(errorData);


            }
        }
    }, [data, isSuccess, loginErr])
    useEffect(() => {
        if (veifySuccess) {
            navigate(`/`)
        }
    }, [veifySuccess])

    console.log(data, isLoading, "loadingsdfghj")


    return (
        <React.Fragment>
            <section className="auth-page-wrapper position-relative bg-light min-vh-100 d-flex align-items-center justify-content-between">
                <div className="auth-header position-fixed top-0 start-0 end-0 bg-body">
                    <Container fluid={true}>
                        <Row className="justify-content-between align-items-center">
                            <Col className="col-2">
                                <Link className="navbar-brand mb-2 mb-sm-0" to="/">
                                    <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="22" />
                                    <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="22" />
                                </Link>
                            </Col>
                            <Col className="col-auto">
                                <ul className="list-unstyled hstack gap-2 mb-0">
                                    <li className="me-md-3">
                                        <Link to="#" className="text-body fw-medium fs-15">Become a Selling</Link>
                                    </li>
                                    <li className="d-none d-md-block">
                                        <Link to="#" className="btn btn-soft-secondary" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i className="bi bi-google-play align-middle me-1"></i> Download App
                                        </Link>
                                    </li>
                                    <li className="d-none d-md-block">
                                        <Link to="#" className="btn btn-soft-primary" data-bs-toggle="dropdown" aria-expanded="false">
                                            <i className="bi bi-apple align-middle me-1"></i> Download App
                                        </Link>
                                    </li>
                                </ul>
                            </Col>
                        </Row>
                    </Container>
                </div>
                <div className="w-100">
                    <Container>
                        <Row className="justify-content-center">
                            <Col lg={6}>
                                <div className="auth-card mx-lg-3">
                                    <Card className="border-0 mb-0">
                                        <Card.Header className="bg-primary border-0">
                                            <Row>
                                                <Col lg={4} className="col-3">
                                                    <img src={img1} alt="" className="img-fluid" />
                                                </Col>
                                                <Col lg={8} className="col-9">
                                                    <h1 className="text-white lh-base fw-lighter">Join Our Toner Store</h1>
                                                </Col>
                                            </Row>
                                        </Card.Header>
                                        <Card.Body>
                                            <p className="text-muted fs-15">Sign in to continue to Toner.</p>
                                            <div className="p-2">
                                                {error && error ? (<Alert variant="danger"> Username and password are invalid. </Alert>) : null}

                                                <Form action="#" onSubmit={(e) => {
                                                    e.preventDefault();
                                                    validation.handleSubmit();
                                                    return false;
                                                }}>

                                                    <div className="mb-3">
                                                        <Form.Label htmlFor="username">Username</Form.Label>
                                                        <Form.Control name="email" type="email" className="form-control" id="username" placeholder="Enter username"
                                                            onChange={validation.handleChange}
                                                            onBlur={validation.handleBlur}
                                                            value={validation.values.email || ""}
                                                            isInvalid={
                                                                validation.touched.email && validation.errors.email ? true : false
                                                            }
                                                        />
                                                        {validation.touched.email && validation.errors.email ? (
                                                            <Form.Control.Feedback type="invalid">{validation.errors.email}</Form.Control.Feedback>
                                                        ) : null}
                                                    </div>

                                                    <div className="mb-3">
                                                        <div className="float-end">
                                                            <Link to="/forgot-password" className="text-muted">Forgot password?</Link>
                                                        </div>
                                                        <Form.Label htmlFor="password-input">Password</Form.Label>
                                                        <div className="position-relative auth-pass-inputgroup mb-3">
                                                            <Form.Control className="form-control pe-5 password-input" placeholder="Enter password" id="password-input"
                                                                name="password"
                                                                value={validation.values.password || ""}
                                                                type={passwordShow ? "text" : "password"}
                                                                onChange={validation.handleChange}
                                                                onBlur={validation.handleBlur}
                                                                isInvalid={
                                                                    validation.touched.password && validation.errors.password ? true : false
                                                                }
                                                            />
                                                            {validation.touched.password && validation.errors.password ? (
                                                                <Form.Control.Feedback type="invalid">{validation.errors.password}</Form.Control.Feedback>
                                                            ) : null}
                                                            <Button variant='link' className="position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button" id="password-addon" onClick={() => setPasswordShow(!passwordShow)}><i className="ri-eye-fill align-middle"></i></Button>
                                                        </div>
                                                    </div>

                                                    <div className="form-check">
                                                        <Form.Check type="checkbox" value="" id="auth-remember-check" />
                                                        <Form.Label htmlFor="auth-remember-check">Remember me</Form.Label>
                                                    </div>

                                                    <div className="mt-4">
                                                        <Button variant='primary' className="w-100" type="submit" disabled={!error ? isLoading : false}>{!error ? isLoading && <Spinner size="sm" animation="border" className="me-2" /> : ""}Sign In</Button>
                                                    </div>

                                                    <div className="mt-4 pt-2 text-center">
                                                        <div className="signin-other-title">
                                                            <h5 className="fs-13 mb-4 title">Sign In with</h5>
                                                        </div>
                                                        <div className="pt-2 hstack gap-2 justify-content-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-soft-primary btn-icon"
                                                                onClick={e => { e.preventDefault(); socialResponse("facebook"); }}>
                                                                <i className="ri-facebook-fill fs-lg"></i>
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-soft-danger btn-icon"
                                                                onClick={e => { e.preventDefault(); socialResponse("google"); }}>
                                                                <i className="ri-google-fill fs-lg"></i>
                                                            </button>
                                                            <Button variant='soft-dark' className="btn-icon"><i className="ri-github-fill fs-16"></i></Button>
                                                            <Button variant='soft-info' className="btn-icon"><i className="ri-twitter-fill fs-16"></i></Button>
                                                        </div>
                                                    </div>
                                                </Form>

                                                <div className="text-center mt-5">
                                                    <p className="mb-0">Don't have an account ? <Link to="/register" className="fw-semibold text-secondary text-decoration-underline"> SignUp</Link> </p>
                                                </div>
                                            </div>
                                        </Card.Body>
                                    </Card>
                                </div>
                            </Col>
                        </Row>
                    </Container>

                    <footer className="footer">
                        <Container>
                            <Row>
                                <Col lg={12}>
                                    <div className="text-center">
                                        <p className="mb-0 text-muted">©
                                            {(new Date().getFullYear())} Toner. Crafted with <i className="mdi mdi-heart text-danger"></i> by Themesbrand
                                        </p>
                                    </div>
                                </Col>
                            </Row>
                        </Container>
                    </footer>
                </div>
            </section>
        </React.Fragment>
    );
};

export default withRouter(Login);
